export default {
  id: 46,
  title: 'Target #46 - Mountains',
  url: 'https://cssbattle.dev/play/46',
  colors: ['#293462', '#FFF1C1', '#FE5F55'],
  solution:
    '<a a><a b><style>body{background:#FFF1C1}a{position:fixed}a[a]{top:140;left:167;background:#FE5F55;width:150;height:150;transform:rotate(45deg);box-shadow:-30px 129px #FE5F55}a[b]{top:0;left:0;width:400;height:300;background:#293462;-webkit-mask-image:radial-gradient(circle at center,transparent 40%,black 40.3%)}</style>',
}
